<div class="routine-template-workspace">
	@if (!routineData()) {
		<loading-spinner />
	} @else {
		<routine-workspace-form [initialConfig]="routineData()" />
	}
</div>
